// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2U6qs","buttons":"styles_buttons__12WMn"};